<template>
    <div class="row">
        <div class="col-12">
            <client-trajectory-enrolments-table
                v-bind="$attrs"
                :columns="columns"
                :filterable="filterable"
            />
        </div>
    </div>
</template>
<script>
    import { ClientTrajectoryEnrolmentsTable } from '~/components/tables'

    export default {
        name: "ClientEnrolmentsTab",

        components: {
            ClientTrajectoryEnrolmentsTable,
        },

        data() {
            return {
                columns: [
                    'name',
                    'city',
                ],
                filterable: [],
            }
        },
    }
</script>
<style scoped></style>